import type { EmptyStateProps } from "./index.types";

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div className="empty-state">
      {icon}
      <strong>{title}</strong>
      <span>{description}</span>
    </div>
  );
}
